// extracted by mini-css-extract-plugin
module.exports = {"c_video":"Video_c_video__kFyAv","a_button":"Video_a_button__nbiGc","controls":"Video_controls__s3BKM","video_background":"Video_video_background__YxK17"};